import Chromeless from '../ui/Appearance/Chromeless';
import { CommentEditorWithIntl as Comment } from '../ui/Appearance/Comment/Comment';
import { FullPageEditor as FullPage } from '../ui/Appearance/FullPage/FullPage';
export default function getUiComponent(appearance) {
  appearance = appearance || 'comment';
  switch (appearance) {
    case 'full-page':
    case 'full-width':
      return FullPage;
    case 'chromeless':
      return Chromeless;
    case 'comment':
      return Comment;
    default:
      throw new Error("Appearance '".concat(appearance, "' is not supported by the editor."));
  }
}